// src/config/api.js
const BASE_URL = "https://api-backend.jnec.org/api";
const BASE_URL_IMAGE = "https://api-backend.jnec.org/";

export {BASE_URL, BASE_URL_IMAGE};
